import { inject } from '@angular/core';
import { BaseFilterState } from './base-filter-state';
import { ColumnFilterState } from '../../models/column-filter-state';
import { FilterSessionManagerService } from '../../services/filter-session-manager.service';

export class BaseSessionFilter<T> extends BaseFilterState<T> {
  private readonly filterSessionManager = inject(FilterSessionManagerService);

  protected loadFilterComponent(ready?: () => void): void {
    if (this.containAsyncData$) {
      this.containAsyncData$.subscribe(() => {
        if (ready) {
          ready();
        }
        this.filterDefinition()!.completed();
      });
    } else {
      if (ready) {
        ready();
      }
      this.filterDefinition()!.completed();
    }
  }

  protected clearFilter(): void {
    this.filterSessionManager.clearFilters();
  }

  protected clearFilterByColumn<T>(column: ColumnFilterState<T>): void {
    this.filterSessionManager.removeFilter(column);
  }

  protected updateSession(filterState: ColumnFilterState<T>): void {
    if (filterState.hasValue()) {
      this.filterSessionManager.updateFilter(filterState);
    } else {
      this.filterSessionManager.removeFilter(filterState);
    }
  }

  protected hasSession(): boolean {
    return this.filterSessionManager.hasSession();
  }

  protected checkAndSetSessionValue(): void {
    if (
      this.filterSessionManager.hasValueFor(this.filterDefinition()!.columnKey)
    ) {
      const sessionValue = this.filterSessionManager.getValue<T>(
        this.filterDefinition()!.columnKey
      );
      this.value.set(sessionValue);
      const filterColumn = this.selectedFilter();
      filterColumn.updateValue(sessionValue);
      filterColumn.assignWithoutTrigger = true;
      this.updateFilter.next(filterColumn);
    }
  }
}
